import React from "react";
import { NavLink } from "react-router-dom";
import { SoccerBall, UsersThree, Trophy, ListNumbers } from "@phosphor-icons/react";
import { useI18n } from "../contexts/I18nContext";

export default function BottomNav() {
  const { t } = useI18n();
  const items = [
    { to: "/app", icon: SoccerBall, label: t("nav_my_tips"), end: true, testid: "nav-my-tips" },
    { to: "/app/groups", icon: UsersThree, label: t("nav_groups"), testid: "nav-groups" },
    { to: "/app/leaderboard", icon: Trophy, label: t("nav_leaderboard"), testid: "nav-leaderboard" },
    { to: "/app/standings", icon: ListNumbers, label: t("nav_standings"), testid: "nav-standings" },
  ];

  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-50 mx-auto max-w-md border-t border-neutral-200 bg-white/95 backdrop-blur-xl px-2 py-2 pb-[calc(env(safe-area-inset-bottom,0px)+8px)]"
      data-testid="bottom-nav"
    >
      <ul className="grid grid-cols-4 gap-1">
        {items.map(({ to, icon: Icon, label, end, testid }) => (
          <li key={to}>
            <NavLink
              to={to}
              end={end}
              data-testid={testid}
              className={({ isActive }) =>
                `flex flex-col items-center gap-0.5 py-2 rounded-xl transition-colors ${
                  isActive ? "text-[#41a42b]" : "text-neutral-400 hover:text-[#02371b]"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <Icon size={22} weight={isActive ? "fill" : "regular"} />
                  <span className="text-[10px] font-bold tracking-wide uppercase">{label}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
